export default __webpack_public_path__ + "static/1465-500fbb1ca75d9e9bd0d9ae8c3db283f9.gif";